import axios from "axios";
import React, { useState, useEffect } from "react";

function Category({ onCategoryChange, selectedCategory }) {
  const [category, setCategory] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}bundle/list-category`)
      .then((res) => {
        console.log("category", res.data.category);
        setCategory(res.data.category);
      });
  }, []);

  return (
    <div className="col">
      <div className="form-outline mb-4">
        <label className="form-label" htmlFor="category">
          Category
        </label>
        <select
          className="form-control form-select col-12"
          id="category"
          onChange={onCategoryChange}
          required
        >
          <option value="" disabled selected>
            Select Category
          </option>
          {category.map((item) => (
            <option
              key={item._id}
              value={item._id}
              selected={item._id == selectedCategory}
            >
              {item.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default Category;
